import * as Utilities from 'Pages/managemenu/subpages/editmenu/utilities';
import { MANAGE_CYCLE_MENU_SET_SAVE_SUCCESSFUL } from 'Pages/managemenu/state/listcycles/types';

import * as types from './types';

export const INITIAL_STATE = {
  numberOfDays: 0,
  analysisDays: 5,
  menuId: null,
  menuTitle: '',
  nutritionStandardId: null,
  fiscalYear: null,
  servings: null,
  error: null,
  menuDaysMap: {},
  saveSuccessful: false,
  recipesById: {},
  weeklyRequirements: [],
  unmetDailyRequirements: [],
  dailyContributions: [],
  analyzing: false,
  fetching: false,

  // Does not include recipes that are children of another recipe
  // Used for determining if the a la carte checkbox should be disabled for duplicates
  recipeCountByDayMap: {},

  viewBy: null,
  disableDeleteRecipe: false,
  reimbMealsByDayMap: {},
  editableAppliedDays: {},
  isReadOnly: false,
  sharedSourceId: null,
  schoolCalendar: null,
  sites: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.RECEIVED_MENU_DETAILS:
      return {
        ...state,
        recipesById: payload.recipesById,
        menuDaysMap: payload.menuDaysMap,
        recipeCountByDayMap: payload.recipeCountByDayMap,
        reimbMealsByDayMap: payload.reimbMealsByDayMap,
        menuId: payload.menuId,
        numberOfDays: payload.numberOfDays,
        menuTitle: payload.menuTitle,
        fiscalYear: payload.fiscalYear,
        nutritionStandardId: payload.nutritionStandardId,
        servings: payload.servings,
        analysisDays: payload.analysisDays,
        editableAppliedDays: payload.editableAppliedDays,
        isReadOnly: payload.isReadOnly,
        sharedSourceId: payload.sharedSourceId,
      };

    case types.REORDER_MENU_ITEMS: {
      const { menuDaysMap, recipesById } = payload;
      return {
        ...state,
        recipesById,
        menuDaysMap,
      };
    }

    case types.CYCLE_MENU_SWITCH_VIEW: {
      const { menuDaysMap, recipesById, viewBy } = payload;
      return {
        ...state,
        viewBy,
        recipesById,
        menuDaysMap,
      };
    }

    case types.REMOVE_RECIPE_CHILD:
    case types.COMBINE_ITEMS:
    case types.MOVE_RECIPE:
    case types.ADD_RECIPE_TO_DAYS:
    case types.ADD_RECIPE_TO_MENU: {
      const { menuDaysMap, recipesById, recipeCountByDayMap } = payload;
      return {
        ...state,
        recipesById,
        menuDaysMap,
        recipeCountByDayMap,
      };
    }

    case types.RESET_MENU_STATE:
      return INITIAL_STATE;

    case types.CYCLE_MENU_SAVE_SUCCESSFUL:
      return {
        ...state,
        saveSuccessful: payload,
      };

    case types.APPLY_CYCLE_MENU:
    case types.CYCLE_MENU_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case MANAGE_CYCLE_MENU_SET_SAVE_SUCCESSFUL: {
      return {
        ...state,
        saveSuccessful: payload,
      };
    }

    case types.DELETE_RECIPES: {
      const {
        menuDaysMap,
        recipesById,
        recipeCountByDayMap,
        reimbMealsByDayMap,
      } = payload;

      return {
        ...state,
        menuDaysMap,
        recipesById,
        recipeCountByDayMap,
        reimbMealsByDayMap,
      };
    }

    case types.UPDATE_RECIPE_PROJECTED_SERVINGS: {
      const { recipeDraggableId, projectedServings } = payload;

      const copy = { ...state.recipesById[recipeDraggableId] };
      copy.ProjectedServings = projectedServings;
      const recipesById = { ...state.recipesById, [recipeDraggableId]: copy };

      return { ...state, recipesById };
    }

    case types.UPDATE_RECIPE_SERVINGS_PERCENTAGE: {
      const { recipeDraggableId, percentage } = payload;

      const copy = { ...state.recipesById[recipeDraggableId] };
      copy.ServingsPercentage = percentage;
      const recipesById = { ...state.recipesById, [recipeDraggableId]: copy };

      return { ...state, recipesById };
    }

    case types.UPDATE_RECIPE_QTY_OF_PORTION: {
      const { recipeDraggableId, qtyOfPortion } = payload;

      const copy = { ...state.recipesById[recipeDraggableId] };
      copy.QtyOfPortion = qtyOfPortion;
      const recipesById = { ...state.recipesById, [recipeDraggableId]: copy };

      return { ...state, recipesById };
    }

    case types.TOGGLE_RECIPE_ALACARTE: {
      const { recipesById, reimbMealsByDayMap } = payload;

      return { ...state, recipesById, reimbMealsByDayMap };
    }

    case types.SET_UNMET_DAILY_REQUIREMENTS:
      return { ...state, unmetDailyRequirements: payload };

    case types.SET_WEEKLY_REQUIREMENTS:
      return { ...state, weeklyRequirements: payload };

    case types.SET_DAILY_CONTRIBUTIONS:
      return { ...state, dailyContributions: payload };
    case types.ANALYZING_CYCLE_MENU:
      return { ...state, analyzing: payload };

    case types.REPLACE_RECIPES: {
      const { recipesById, reimbMealsByDayMap, recipeCountByDayMap } = payload;
      return { ...state, recipesById, reimbMealsByDayMap, recipeCountByDayMap };
    }

    case types.CHANGE_RECIPE_DISPLAY_ON_CALENDAR: {
      const { recipesById } = payload;

      return { ...state, recipesById };
    }

    case types.APPLY_CYCLE_MENU_ERROR:
    case types.CYCLE_MENU_FETCH_ERROR:
    case types.ANALYZE_CYCLE_MENU_ERROR:
    case types.SET_ERROR:
      return { ...state, error: payload };

    case types.CLEAR_ERROR:
      return { ...state, error: null };

    case types.DISABLE_DELETE_RECIPE:
      return { ...state, disableDeleteRecipe: payload.disable };

    case types.ADD_REIMB_MEAL: {
      const { reimbMeal, dayNumber } = payload;

      return {
        ...state,
        reimbMealsByDayMap: Utilities.addReimbMeal(
          state.reimbMealsByDayMap,
          reimbMeal,
          dayNumber
        ),
      };
    }

    case types.ADD_RECIPE_TO_REIMB_MEAL:
    case types.REMOVE_RECIPE_FROM_REIMB_MEALS:
    case types.MOVE_REIMB_MEAL_RECIPE:
    case types.ADD_RECIPE_TO_REIMB_MEALS:
    case types.UPDATE_REIMB_MEAL_CONTRIBUTION:
      return { ...state, reimbMealsByDayMap: payload };
    case types.GET_SCHOOL_CALENDAR:
      return { ...state, schoolCalendar: payload };
    case types.GET_CYCLE_MENU_SITES:
      return { ...state, sites: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/editmenu/reducer.js